import { AppState } from '../../types';
import { ElementPropertyRuleRecord } from '@fullstory/proto/fs/services/search-settings';
import { createSelector } from 'reselect';

export const getElementPropertyRulesById = (
  state: AppState,
): Map<string, ElementPropertyRuleRecord> =>
  state.elementPropertyRules.elementPropertyRules ?? new Map();

export const getAllElementPropertyRulesLoading = (state: AppState) =>
  state.elementPropertyRules.getAllElementPropertyRules.loading;

export const getAllElementPropertyRules = createSelector(getElementPropertyRulesById, byId => {
  const elementPropertyRules = [...byId.values()];
  elementPropertyRules.sort((a, b) => {
    const aName = a.elementPropertyRule?.name || '';
    const bName = b.elementPropertyRule?.name || '';
    return aName.localeCompare(bName);
  });
  return elementPropertyRules;
});

export const getUnarchivedElementPropertyRules = createSelector(getAllElementPropertyRules, rules =>
  rules.filter(rule => !rule?.metadata?.archived),
);

export const getUnarchivedElementPropertyRulesByName = createSelector(
  getElementPropertyRulesById,
  byId => {
    const byName = new Map<string, ElementPropertyRuleRecord>();
    byId.forEach(elementPropertyRule => {
      if (!elementPropertyRule?.metadata?.archived && elementPropertyRule.elementPropertyRule) {
        byName.set(elementPropertyRule.elementPropertyRule.name, elementPropertyRule);
      }
    });
    return byName;
  },
);
